<script setup>
// import { ref } from 'vue';
import ArgonInput from "@/components/ArgonInput.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
</script>
<template>
<div class="py-4 container-fluid ">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header pb-0">
                <h6>Edit Sawit Buah - Block: {{ model.sawitbuah.blockid }}</h6>
                </div>
                <div class="container-fluid">
                    <div class="row ">
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Block Id(s)</label>
                            <input class="form-control" v-model="model.sawitbuah.blockid" id="input_block_name" type="text" placeholder="A01,A02,A03" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Weight (KG)</label>
                            <input class="form-control" v-model="model.sawitbuah.weight" id="input_weight" type="number" placeholder="1" />
                        </div>
                        <!-- <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Quantity (Biji)</label>
                            <input class="form-control" v-model="model.sawitbuah.quantity" id="input_quantity" type="number" placeholder="200" />
                        </div> -->
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Date</label>
                            <input type="date" id="input_date" v-model="model.sawitbuah.sell_at" class="form-control" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Price (Est.)(RM)</label>
                            <input class="form-control" v-model="model.sawitbuah.price" id="input_price" type="number" placeholder="750" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Sell To</label>
                            <argon-input type="text" v-model="model.sawitbuah.sellto" id="input_sellto" placeholder="Ican Bukit Kuang" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Perkerja</label>
                            <select class="form-control" v-model="model.sawitbuah.perkerja">
                                <option value="0">Dani</option>
                                <option value="1">Perkerja sendiri</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Remark</label>
                            <argon-input type="text" id="input_remark" v-model="model.sawitbuah.remark"  placeholder="Remark...." />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <button class="btn btn-success " @click="updateSawitBuah" style="float: right;" id="btn_add" disabled>Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</div>
</template>


<script>
import axios from 'axios';

export default {
  name:'vehicleEdit',
  data(){
    return {
    //   errorList: '',
    model:{
        sawitbuah:{
            sawitbuahsalesid:'',
            blockid:'',
            weight:'',
            remark:'',
            price:'',
            perkerja:'0',
            quantity:'0',
            sellto:'Ican Bukit Kuang',
            sell_at: new Date().toISOString().slice(0,10),
        },
      },
    }
  },
  mounted(){
    this.model.sawitbuah.sawitbuahsalesid = this.$route.params.id;
    this.getSawitBuahByID();
  },
  methods: {
    updateSawitBuah(){
        this.model.sawitbuah.username = localStorage.getItem('username');
        // console.log(this.model.vehicle);
        axios.post('block/updateSawitBuah',this.model.sawitbuah)
            .then(res => {
                alert(res.data.message);
                
            }).catch(function (error){
                console.log('Error',error.message);
            });
    },
    getSawitBuahByID(){
        // var mythis = this;
        axios.get('block/getSawitBuahByID/' + this.$route.params.id)
            .then(res => {
                console.log(res.data.sawitbuahsales[0]);
                this.model.sawitbuah = res.data.sawitbuahsales[0];
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Name, Company, Contact, State and Address is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    }
    
  },
}
</script>